import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;
const SYS = Global.system;

class TrustedWorkerService {
    getTrustedWorker(url) {
        var ruta = `${API_URL}/trusted-worker?sys=${SYS}&url=${url}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }

    saveTrustedWorker(url, body) {
        var ruta = `${API_URL}/trusted-worker?sys=${SYS}&url=${url}`;
        return axios.post(ruta, body, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }

    deleteTrustedWorker(url, id) {
        let ruta = `${API_URL}/trusted-worker/${id}?sys=${SYS}&url=${url}`;
        return axios.delete(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
}

export default new TrustedWorkerService();
